export default class OffreHero {
    static init() {
        if (!document.body.classList.contains('single-job_offer')) {
            return;
        }

        this.hero = document.querySelector('.hero-detail-offre');

        if (!this.hero) {
            return;
        }

        this.bindEvents();
        this.update();
    }

    static bindEvents() {
        window.addEventListener('scroll', this.update.bind(this), { passive: true });
        window.addEventListener('resize', this.update.bind(this));
    }

    static update() {
        const rect = this.hero.getBoundingClientRect();
        const isHidden = rect.bottom <= 0 || rect.top >= window.innerHeight;

        this.hero.classList.toggle('fix-it', isHidden);
    }
}